import { AdvancedSettingsController } from './advancedSettings.controller';
import template from './advancedSettings.html';

export const createRequestAdvancedSettingsComponent = {
  name: 'createRequestAdvancedSettings',
  restrict: 'E',
  template,
  controller: AdvancedSettingsController,
  controllerAs: 'vm',
  bindings: {
    descriptionTitle: '@',
    descriptionText: '@',
    isOpen: '<',
    model: '=',
    form: '=',
  },
};
